import { gql } from 'graphql-query-contracts';

export const addUserToWorkOrderComments = gql(`
  mutation AddUserToWorkOrderComments($serviceRequestId: String!) {
    addUserToWorkOrderComments(serviceRequestId: $serviceRequestId)
  }
`);
